import React, { useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import FileReader from './components/FileReader';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useBatchUploadContactsMutation } from '../list-manager/api/contacts';
import { useSearchParams } from "react-router-dom";
import { CircularProgress } from '@mui/material';
import { useAuthSession } from '../../../../Auth';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  "& .MuiDialog-paper": {
    width: "auto", // Let it grow with content
    maxWidth: "90vw", // Prevent it from overflowing viewport
    overflowX: "auto", // Add scroll if it still overflows
  },
}));

export default function ImportContactsModal() {
  const [open, setOpen] = React.useState(false);
  const [searchParams] = useSearchParams();
  const [dataToUpload, setDataToUpload] = useState<ContactToUpload[] | undefined>();
  const { mutate, isPending, isSuccess, reset, error } = useBatchUploadContactsMutation(); 
  const { name: user_name } = useAuthSession();

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    reset();
  };

  const handleUpload = () => {
    if(dataToUpload) {
      mutate({
        created_by: user_name,
        values: dataToUpload,
      });
    }
  };

  return (
    <React.Fragment>
      <Button
        startIcon={<FileUploadIcon />}
        variant="text"
        onClick={handleClickOpen}
      >
        Import
      </Button>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="xl"
      >
        <DialogTitle sx={{ m: 0, p: 2,  }} id="customized-dialog-title">
          Import Contacts
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <FileReader onDataReady={setDataToUpload} error={error} isSuccess={isSuccess} isPending={isPending} />
        </DialogContent>
        {isSuccess ? (
          <DialogActions>
            <Button onClick={handleClose}>Close</Button>
            <Button
              autoFocus
              onClick={reset}
            >
              Upload More
            </Button>
          </DialogActions>
        ) : (
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button
              autoFocus
              onClick={handleUpload}
              disabled={!dataToUpload || dataToUpload.length === 0}
            >
              Import Contacts
            </Button>
          </DialogActions>
        )}
      </BootstrapDialog>
    </React.Fragment>
  );
}